module.exports = __webpack_public_path__ + "img/successful.b243f734.svg";